// extracted by mini-css-extract-plugin
export default {"categories":"N8NvQ9","desktop":"y223a5","mobile":"E8qQyb"};